module.exports = __webpack_public_path__ + "static/media/08_APOTHEO_LABO_BIODERMA.3613f56f.png";